document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('#faqs_page .panel-title a').forEach(function (link) {
        link.removeAttribute("data-toggle"); // Verwijdert Bootstrap toggle functionaliteit alleen bij FAQ's
        link.addEventListener('click', function (event) {
            event.preventDefault();
            let target = document.querySelector(this.getAttribute('href'));

            if (target.classList.contains('show')) {
                target.classList.remove('show');
                target.style.display = "none"; // Direct verbergen
            } else {
                document.querySelectorAll('#faqs_page .panel-collapse').forEach(collapse => {
                    collapse.classList.remove('show');
                    collapse.style.display = "none";
                });
                target.classList.add('show');
                target.style.display = "block"; // Direct tonen
            }
        });
    });
});
